import {FormControl, FormGroup} from '@angular/forms';
import {
    BrokerGetOutputModel,
    BrokerUpdateInputModel,
    HttpStatusCodesEnum,
    OrderRouteService,
    ServerResponse,
    ServerResponseData
} from '@spa/api';
import {BrokerFormControlsInterface} from 'appAssets/descriptors';
import {Helper} from 'appShared/classes';
import {map} from 'rxjs/operators';
import {
    BrokerFormControls
} from 'appAssets/descriptors';
import {OrderRoutesFormErrorStatesEnum} from '../../enums';
import {BrokerGetOutputInterface} from '@spa/api/lib/interfaces';

export class BrokerForm {
    private orderRouteService: OrderRouteService;
    public formGroup: FormGroup;
    public controls: BrokerFormControlsInterface;
    public brokerId?: number;
    public brokerModel: BrokerUpdateInputModel;

    constructor(orderRouteService: OrderRouteService, brokerId?: number, brokerModel?: BrokerUpdateInputModel) {
        this.brokerId = brokerId;
        this.orderRouteService = orderRouteService;
        this.brokerModel = brokerModel;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});
        this.controls = BrokerFormControls();
        Object.keys(this.controls).forEach((formItemKey: string) => {
            const control = this.controls[formItemKey];
            switch (control.name) {
                case BrokerUpdateInputModel.getNameSelector():
                    control.value = !this.brokerModel ? null : this.brokerModel.getName();
                    break;
                case BrokerUpdateInputModel.getCodeSelector():
                    control.value = !this.brokerModel ? null : this.brokerModel.getCode();
                    break;
            }

            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }

    updateBroker(): ServerResponse<BrokerGetOutputModel> {
        const clonedModel = this.brokerModel.serialize();

        this.brokerModel.setName(this.formGroup.value[this.controls.name.name]);
        this.brokerModel.setCode(this.formGroup.value[this.controls.code.name]);

        return this.orderRouteService.updateBroker(this.brokerId, this.brokerModel.serialize())
            .pipe(
                map((response: ServerResponseData<null>) => {
                    if (response.status !== HttpStatusCodesEnum.Ok) {
                        this.brokerModel = new BrokerUpdateInputModel(clonedModel.name, clonedModel.code);

                        return Helper.errorsHelper().createErrorResponse<null>(
                            response,
                            OrderRoutesFormErrorStatesEnum.UpdateBrokersFailed
                        );
                    }

                    return Helper.createSuccessResponse<BrokerGetOutputModel>(new BrokerGetOutputModel({
                        name: this.brokerModel.getName(),
                        code: this.brokerModel.getCode(),
                        id: this.brokerId,
                        status: null,
                        created_by_id: null,
                        created_at: null,
                    }));
                })
            );
    }

    registerBroker(): ServerResponse<BrokerGetOutputModel> {
        const inputModel = new BrokerUpdateInputModel(
            this.formGroup.value[this.controls.name.name],
            this.formGroup.value[this.controls.code.name]
        );

        return this.orderRouteService.createBroker(inputModel.serialize()).pipe(
            map((response: ServerResponseData<BrokerGetOutputInterface>) => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponse<BrokerGetOutputInterface>(
                        response,
                        OrderRoutesFormErrorStatesEnum.CreateBrokersFailed
                    );
                }
                const data = response.data as BrokerGetOutputInterface;

                return Helper.createSuccessResponse<BrokerGetOutputModel>(new BrokerGetOutputModel(data));
            })
        );
    }


    createRequest(): ServerResponse<BrokerGetOutputModel> {
        if (!this.brokerModel) {
            return this.registerBroker();
        }

        return this.updateBroker();
    }

    validateForm(messagesFunction: (controlsLabel?: string) => { [key: string]: string }): boolean {
        let isInvalidForm = false;
        if (this.formGroup.invalid) {
            Object.keys(this.controls).forEach((controlKey: string) => {
                const controlName = this.controls[controlKey].name;
                const formControl = this.formGroup.get(controlName);

                if (formControl && formControl.invalid) {
                    const errors = Object.keys(formControl.errors).map((errorKey: string) => {
                        return messagesFunction(this.controls[controlKey].placeholder)[errorKey];
                    });

                    this.controls[controlKey].setErrors(errors);
                }

            });
            isInvalidForm = true;
        }

        return !isInvalidForm;
    }
}
